import { AmountControl } from '@src/components/ui/AmountControl';
import { TermControl } from '@src/components/ui/TermControl';
import { FILTERS_NAMES } from '@src/constants/filters';
import { HelperText } from 'shared/ui/HelperText';

type Props = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  postfix: string;
  error?: string;
  helperText?: string;
  isAmountField?: boolean;
};
export const FieldControl = ({ label, value, onChange, postfix, error, helperText, isAmountField }: Props) => (
  <div>
    {isAmountField ? (
      <AmountControl name={FILTERS_NAMES.AMOUNT} label={label} value={value} onChange={onChange} postfix={postfix} />
    ) : (
      <TermControl name={FILTERS_NAMES.TERM} label={label} value={value} onChange={onChange} postfix={postfix} />
    )}
    <HelperText error={error} text={helperText} />
  </div>
);
